<template>
  <div class="field">
    <label class="field__label" for="org">{{ t("auth.providerName") }}</label>
    <input id="org" :value="organisationName" class="input" maxlength="160" required
           @input="emit('update:organisationName', $event.target.value)" />
    <span class="field__hint">{{ t("auth.providerNameHint") }}</span>
  </div>
  <div class="field">
    <label class="field__label" for="support">{{ t("auth.supportEmail") }}</label>
    <input id="support" :value="supportEmail" class="input" type="email" required
           @input="emit('update:supportEmail', $event.target.value)" />
    <span class="field__hint">{{ t("auth.supportEmailHint") }}</span>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";

defineProps({ organisationName: { type: String, default: "" }, supportEmail: { type: String, default: "" } });
const emit = defineEmits(["update:organisationName", "update:supportEmail"]);
const { t } = useI18n();
</script>
